<template>
  <div class="group-entry-page">
    <h2 class="page-title">分组信息录入</h2>

    <div class="card form-card">
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <span class="label">选择人员：</span>
            <div class="custom-select person-select" @click.stop>
              <input
                type="text"
                v-model="personSearchText"
                :placeholder="selectedPerson ? selectedPersonLabel : '请选择人员'"
                @focus="personDropdownVisible = true"
                @input="personDropdownVisible = true"
              />
              <i v-if="selectedPerson" class="clear-btn" @click.stop="clearPerson">×</i>
              <div class="dropdown-list" v-show="personDropdownVisible">
                <div
                  v-for="item in filteredPersonOptions"
                  :key="item.id"
                  class="dropdown-item"
                  :class="{ active: selectedPerson === item.id }"
                  @click="selectPerson(item.id)"
                >
                  {{ item.nickname }}
                </div>
                <div v-if="filteredPersonOptions.length === 0" class="dropdown-empty">无匹配数据</div>
              </div>
            </div>
          </div>

          <div class="form-item">
            <span class="label">选择组别：</span>
            <div class="custom-select group-select" @click.stop>
              <input
                type="text"
                readonly
                :value="selectedGroup"
                placeholder="请选择组别"
                @focus="groupDropdownVisible = true"
              />
              <i v-if="selectedGroup" class="clear-btn" @click.stop="clearGroup">×</i>
              <div class="dropdown-list" v-show="groupDropdownVisible">
                <div
                  v-for="group in groupOptions"
                  :key="group"
                  class="dropdown-item"
                  :class="{ active: selectedGroup === group }"
                  @click="selectGroup(group)"
                >
                  {{ group }}
                </div>
              </div>
            </div>
          </div>

          <button class="btn btn-primary" @click="handleConfirm">确定</button>
        </div>
      </div>
    </div>

    <div class="card result-card">
      <div class="card-header">
        <span>当前分组结果</span>
        <div>
          <button class="btn btn-primary" @click="handleSubmit">提交分组</button>
          <button class="btn btn-text" @click="resetGroups">清空全部分组</button>
        </div>
      </div>
      <div class="card-body">
        <div class="group-list">
          <div v-for="group in groupOptions" :key="group" class="group-item">
            <div class="group-title">{{ group }}（{{ groups[group].length }}人）</div>
            <div class="person-tags">
              <span
                v-for="personId in groups[group]"
                :key="personId"
                class="tag"
              >
                {{ getPersonName(personId) }}
                <i class="tag-close" @click="removePerson(group, personId)">×</i>
              </span>
              <span v-if="groups[group].length === 0" class="empty-tip">暂无人员</span>
            </div>
          </div>
        </div>

        <!-- <div class="json-section">
          <h4>JSON 存储数据</h4>
          <pre>{{ groupJson }}</pre>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import personData from './data-0622.js'

export default {
  name: 'PageGroups',
  data () {
    return {
      selectedPerson: '',
      selectedGroup: '',
      personSearchText: '',
      personDropdownVisible: false,
      groupDropdownVisible: false,
      personOptions: personData || [],
      groupOptions: ['1组', '2组', '3组', '4组', '5组', '6组', '7组', '8组'],
      groups: {
        '1组': [],
        '2组': [],
        '3组': [],
        '4组': [],
        '5组': [],
        '6组': [],
        '7组': [],
        '8组': []
      }
    }
  },
  computed: {
    groupJson () {
      return JSON.stringify(this.groups, null, 2)
    },
    filteredPersonOptions () {
      const keyword = this.personSearchText.trim().toLowerCase()
      const available = this.personOptions.filter(item => !this.isPersonGrouped(item.id))
      if (!keyword) return available
      return available.filter(item =>
        item.nickname.toLowerCase().includes(keyword)
      )
    },
    selectedPersonLabel () {
      const person = this.personOptions.find(item => item.id === this.selectedPerson)
      return person ? person.nickname : ''
    }
  },
  mounted () {
    this.getAllUserInfo()
    this.getGroupsInfo()
    document.addEventListener('click', this.closeDropdowns)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDropdowns)
  },
  methods: {
    getGroupsInfo () {
      axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/kv/get/groups`,
        method: 'get'
      })
        .then((res) => {
          if (res.data.data) {
            this.groups = JSON.parse(res.data.data)
          }
        })
    },
    getAllUserInfo () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/getAll`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
        .then((res) => {
          // console.log('所有主播数据：', res.data)
          if (res.status === 200 && res.data && res.data.data && res.data.data.length) {
            this.userList = res.data.data.map((item) => {
              item.nickname += '·716'
              return item
            })
          }
        })
    },
    handleSubmit () {
      axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/kv/set/groups`,
        method: 'post',
        headers: {
          'tenant-id': 1
        },
        data: {
          value: this.groupJson
        }
      })
        .then((res) => {
          alert('提交成功')
        }).catch(() => {
          alert('提交失败')
        })
    },
    getPersonName (id) {
      const person = this.personOptions.find(item => item.id === id)
      return person ? person.nickname : id
    },
    isPersonGrouped (id) {
      return this.groupOptions.some(group => this.groups[group].includes(id))
    },
    selectPerson (id) {
      this.selectedPerson = id
      this.personSearchText = this.selectedPersonLabel
      this.personDropdownVisible = false
    },
    clearPerson () {
      this.selectedPerson = ''
      this.personSearchText = ''
      this.personDropdownVisible = false
    },
    selectGroup (group) {
      this.selectedGroup = group
      this.groupDropdownVisible = false
    },
    clearGroup () {
      this.selectedGroup = ''
      this.groupDropdownVisible = false
    },
    closeDropdowns () {
      this.personDropdownVisible = false
      this.groupDropdownVisible = false
    },
    handleConfirm () {
      if (!this.selectedPerson) {
        alert('请选择人员')
        return
      }
      if (!this.selectedGroup) {
        alert('请选择组别')
        return
      }

      const targetGroup = this.groups[this.selectedGroup]
      if (!targetGroup.includes(this.selectedPerson)) {
        targetGroup.push(this.selectedPerson)
      } else {
        alert('该人员已在当前组别中')
        return
      }

      this.saveGroups(this.groups)

      this.selectedPerson = ''
      this.selectedGroup = ''
      this.personSearchText = ''
      // alert('录入成功')
    },
    removePerson (group, personId) {
      const index = this.groups[group].indexOf(personId)
      if (index > -1) {
        this.groups[group].splice(index, 1)
        this.saveGroups(this.groups)
        alert('移除成功')
      }
    },
    resetGroups () {
      this.groupOptions.forEach(group => {
        this.$set(this.groups, group, [])
      })
      this.saveGroups(this.groups)
      alert('已清空全部分组')
    },
    // 预留方法：后续替换为真实接口
    saveGroups (data) {
      const json = JSON.stringify(data)
      console.log('分组信息JSON：', json)
      // TODO: 替换为真实接口
      // return this.$http.post('/api/saveGroups', { data: json })
    }
  }
}
</script>

<style scoped>
.group-entry-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.page-title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.card-header {
  padding: 14px 20px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #303133;
}

.card-body {
  padding: 20px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.form-item {
  display: flex;
  align-items: center;
}

.label {
  margin-right: 8px;
  color: #606266;
  font-weight: 500;
  font-size: 14px;
}

.custom-select {
  position: relative;
  width: 260px;
}

.custom-select.group-select {
  width: 160px;
}

.custom-select input {
  width: 100%;
  height: 36px;
  padding: 0 30px 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
}

.custom-select input:focus {
  border-color: #409eff;
}

.clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #c0c4cc;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
}

.clear-btn:hover {
  color: #909399;
}

.dropdown-list {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  z-index: 1000;
  box-sizing: border-box;
}

.dropdown-item {
  padding: 10px 12px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-item:hover,
.dropdown-item.active {
  background: #f5f7fa;
  color: #409eff;
}

.dropdown-empty {
  padding: 20px 12px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 0 20px;
  font-size: 14px;
  border-radius: 4px;
  height: 36px;
}

.btn-primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.btn-primary:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.btn-text {
  color: #409eff;
  background: transparent;
  border-color: transparent;
  padding: 0 10px;
  height: auto;
}

.btn-text:hover {
  color: #66b1ff;
}

.group-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.group-item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}

.group-title {
  font-weight: bold;
  margin-bottom: 8px;
  color: #303133;
  font-size: 14px;
}

.person-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 32px;
}

.tag {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 8px;
  line-height: 1;
  font-size: 12px;
  color: #409eff;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  white-space: nowrap;
}

.tag-close {
  display: inline-block;
  margin-left: 6px;
  font-style: normal;
  font-size: 14px;
  cursor: pointer;
  color: #409eff;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
}

.tag-close:hover {
  color: #fff;
  background: #409eff;
  border-radius: 50%;
}

.empty-tip {
  color: #909399;
  font-size: 12px;
  line-height: 28px;
}

.json-section h4 {
  margin-bottom: 8px;
  color: #303133;
  font-size: 14px;
}

.json-section pre {
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 12px;
  max-height: 300px;
  color: #333;
  border: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/components/page260622/page-groups.vue